/* MIcase 2026-08-15 · Foto real por diseno en las lineas del carrito.

   DE DONDE VIENE: estaba en linea dentro de snippets/micase-modelo.liquid, o sea dentro
   del <head> de TODAS las paginas, repetido en cada HTML. Sale a un asset con defer para
   que se cachee entre paginas, que es la regla de ligereza del proyecto.

   POR QUE ES SEGURO MOVERLO: no pinta nada del primer pintado. Solo cambia el src de las
   miniaturas de hidrogel dentro del carrito, y ya esperaba a DOMContentLoaded por su
   cuenta; con defer arranca en ese mismo momento. Nadie mas lo llama: la bandera
   window.__mcDisFotoOn solo aparece en este archivo.

   ------------------------------------------------------------------------------------
   2026-08-22 · ESTE ARCHIVO YA NO ES QUIEN PONE LA FOTO. AHORA ES LA RED.

   Sebastian, en el repaso de repintados: la linea salia con la foto generica y 120 ms
   despues este script le cambiaba el src por la del diseno -que ademas todavia habia que
   descargar-. Foto A, hueco, foto B, cada vez que se abria el carrito.

   La foto correcta la escribe ahora el SERVIDOR, con snippets/micase-foto-diseno.liquid,
   desde snippets/cart-drawer.liquid y sections/micase-carrito.liquid, que son las dos
   unicas superficies de carrito con foto de linea que tiene el tema (settings.cart_type
   es 'drawer', asi que snippets/cart-notification.liquid no se usa, y templates/cart.json
   monta micase-carrito, no main-cart-items). Como llega ya bien, no hay nada que cambiar
   y no hay parpadeo.

   ESTE ARCHIVO SE QUEDA por dos razones: cubre cualquier superficie de carrito futura
   que no pase por esos dos archivos, y sigue siendo la red si el snippet fallara.

   DOS CAMBIOS, los dos para que la red no cueste:
     1. Si la imagen YA trae data-mcdis-foto, no se toca. Antes se comparaba el valor con
        el archivo esperado; ahora basta con que el atributo exista, porque el servidor lo
        pone junto con el src bueno. Es la misma idea: no reescribir lo que ya esta bien.
     2. El observador deja de vigilar TODO document.body con subtree. Vigilaba la pagina
        entera y, en cada cambio del DOM en cualquier parte, recorria
        'dd,dt,p,span,small,li,td,div' de toda la pagina. Ahora vigila solo los
        contenedores de carrito que existan. Si no hay ninguno, no vigila nada.
   ------------------------------------------------------------------------------------
*/
(function(){
  if (window.__mcDisFotoOn) { return; }
  window.__mcDisFotoOn = 1;

  var CDN = 'https://cdn.shopify.com/s/files/1/0417/3922/3189/files/';
  var MAPA = {
    'carbono negro': 'HidrogelTrasero_11',
    'galaxia negro': 'HidrogelTrasero_13',
    'galaxia azul': 'HidrogelTrasero_2',
    'galaxia violeta': 'HidrogelTrasero_8',
    'tornasol': 'HidrogelTrasero_4',
    'tornasol oscuro': 'HidrogelTrasero_5',
    'white rose gold': 'HidrogelTrasero_7',
    'snake leather': 'HidrogelTrasero_9',
    'asimetric leather': 'HidrogelTrasero_10'
  };
  var RX = /dise[nñ]o\s*:\s*([^\n\r|·•]{3,40})/i;
  var SEL = 'dd,dt,p,span,small,li,td,div';

  function limpia(s){
    return String(s == null ? '' : s).toLowerCase().normalize('NFD')
      .replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function aplica(){
    var nodos = document.querySelectorAll(SEL);
    for (var i = 0; i < nodos.length; i++) {
      var el = nodos[i];
      if (el.children.length > 3) { continue; }
      var m = (el.textContent || '').match(RX);
      if (!m) { continue; }
      var archivo = MAPA[limpia(m[1])];
      if (!archivo) { continue; }

      // se sube hasta 8 niveles buscando la foto de ESA linea del carrito
      var p = el, img = null, n = 0;
      while (p && n++ < 8) {
        img = p.querySelector('img');
        if (img) { break; }
        p = p.parentElement;
      }
      if (!img) { continue; }

      var src = (img.currentSrc || img.getAttribute('src') || '').toLowerCase();
      if (src.indexOf('hidrogel') < 0) { continue; }
      if (img.hasAttribute('data-mcdis-foto')) { continue; }

      img.setAttribute('data-mcdis-foto', archivo);
      img.removeAttribute('srcset');
      img.removeAttribute('data-srcset');
      img.removeAttribute('sizes');
      img.setAttribute('src', CDN + archivo + '.jpg?width=300');
    }
  }

  var t = null;
  function pide(){
    if (t) { clearTimeout(t); }
    t = setTimeout(aplica, 120);
  }

  /* Solo los contenedores de carrito, nunca la pagina entera. */
  var CAJAS = ['#CartDrawer', '.mccart', '#main-cart-items', 'cart-notification'];

  function vigila(){
    if (!window.MutationObserver) { return; }
    var mo = new MutationObserver(pide);
    for (var i = 0; i < CAJAS.length; i++) {
      var n = document.querySelector(CAJAS[i]);
      if (n) { mo.observe(n, { childList: true, subtree: true }); }
    }
  }

  function arranca(){
    aplica();
    vigila();
    document.addEventListener('micase:carrito', pide);
    window.addEventListener('pageshow', pide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranca);
  } else {
    arranca();
  }
})();